import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { orderCreationSlice } from "../orderCreationSlice";

export const Welcome = () => {
  const dispatch = useDispatch();
  const beginForm = () => {
    dispatch(orderCreationSlice.actions.startOrderCreation());
  };

  return (
    <>
      <div className="intro">
        <h3 className="main-heading">Neue Aufträge und Bestellungen</h3>
        <div className="divider" />
        <p className="text">
          Lege Bestellungen an, die Du über Deinen Vertrieb vor Ort, am Telefon
          oder via Fax erhalten hast.
          <br />
          <br />
          Lege der Bestellung bitte einen eigens erstellten Lieferschein bei.
        </p>
        <div className="divider" />
      </div>
      <Button className="btn btn-secondary" onClick={beginForm}>
        Bestellung anlegen
      </Button>
    </>
  );
};
